module.exports = __webpack_public_path__ + "img/open--box.b3faec85.svg";